import awardFeatherSvg from '@listening/assets/astro/images/awardFeather.svg';
import ellipse24Png from '@listening/assets/astro/images/Ellipse-24.png';
import ellipse26Png from '@listening/assets/astro/images/Ellipse-26.png';
import ellipse27Png from '@listening/assets/astro/images/Ellipse-27.png';
import ellipse28Png from '@listening/assets/astro/images/Ellipse-28.png';
import ellipse29Png from '@listening/assets/astro/images/Ellipse-29.png';
import frame13627898303xPng from '@listening/assets/astro/images/Frame-13627898303x.png';
import player3xPng from '@listening/assets/astro/images/Player3x.png';
import starSvg from '@listening/assets/astro/images/star.svg';
import voiceLivWebp from '@listening/assets/astro/images/voice-avatars/voice-liv.webp';
import voiceWillWebp from '@listening/assets/astro/images/voice-avatars/voice-will.webp';

import { CtaButton } from '@/components/astro/cta-button/cta-button';
import { VoiceSample } from '@/components/astro/features/voice-sample';

export function HeroHeadingSection() {
  return (
    <section className='flex w-full flex-col-reverse items-center justify-center gap-[150px] overflow-hidden px-5 pt-[53px] pb-0 sm:px-14 sm:pt-18 sm:pb-35 md:flex-row md:gap-0 lg:px-18'>
      <div className='flex w-full max-w-[1296px] flex-col-reverse items-center justify-between gap-37 pt-13 sm:pt-0 md:gap-25 lg:flex-row-reverse lg:items-start'>
        <div className='mr-0 hidden flex-[0_auto] sm:flex xl:mr-25'>
          <div className='relative left-0 min-w-[268px] lg:justify-center'>
            <div className='absolute inset-0 flex items-center justify-center'>
              <div className='absolute size-[414px] rounded-full border border-solid border-cloud-250/70' />
              <div className='absolute size-[552px] rounded-full border border-solid border-cloud-250/60' />
              <div className='absolute size-[739px] rounded-full border border-solid border-cloud-250/50' />
              <div className='absolute hidden size-[1044px] rounded-full border border-solid border-cloud-250/30 lg:block' />
              <img
                alt='Decorative circle'
                className='absolute top-[15px] left-[-142px]'
                loading='lazy'
                src={ellipse28Png}
              />
              <img
                alt='Decorative circle'
                className='absolute bottom-[194px] left-[-87px]'
                loading='lazy'
                src={ellipse24Png}
              />
              <img
                alt='avatar'
                className='absolute bottom-[143px] left-[-232px]'
                loading='lazy'
                src={ellipse26Png}
              />
              <img
                alt='avatar'
                className='absolute right-[-123px] bottom-[-13px]'
                loading='lazy'
                src={ellipse27Png}
              />
              <img
                alt='avatar'
                className='absolute top-[176px] right-[-154px]'
                loading='lazy'
                src={ellipse29Png}
              />
            </div>
            <img
              alt='App interface preview'
              className='absolute top-[67px] left-[-13px] z-10 rounded-[16px] [box-shadow:0_5px_42px_rgba(193,_216,_251,_.5)]'
              loading='lazy'
              src={frame13627898303xPng}
            />
            <img
              alt='Player interface'
              className='relative block h-[581px] w-[268px] min-w-[268px] rounded-[30px] bg-white object-fill [box-shadow:0_4px_34px_rgba(193,_216,_251,_.5)]'
              loading='eager'
              src={player3xPng}
            />
            <div className='absolute inset-x-[-50px] bottom-[-140px] flex items-center justify-center'>
              <div className='z-20 flex w-[300px] justify-center gap-6 bg-white'>
                <img alt='Feather' loading='lazy' src={awardFeatherSvg} />
                <div className='flex flex-col items-center justify-center gap-1'>
                  <div className='flex justify-center'>
                    <img alt='Rating star' loading='lazy' src={starSvg} />
                    <img alt='Rating star' loading='lazy' src={starSvg} />
                    <img alt='Rating star' loading='lazy' src={starSvg} />
                    <img alt='Rating star' loading='lazy' src={starSvg} />
                    <img alt='Rating star' loading='lazy' src={starSvg} />
                  </div>
                  <div className='text-center text-[16px] leading-[17px] font-[600] text-neutral-840'>
                    1,000+
                    <br />5 Star Reviews
                    <br />
                  </div>
                </div>
                <img
                  alt='Feather'
                  className='[transform:rotateX(0)rotateY(-180deg)rotateZ(0)] [transform-style:preserve-3d]'
                  loading='lazy'
                  src={awardFeatherSvg}
                />
              </div>
            </div>
          </div>
        </div>
        <div className='relative mb-10 flex w-full flex-col items-start gap-8 lg:mb-0 lg:flex-[0_4_700px]'>
          <div className='flex max-w-[604px] flex-col items-start gap-7'>
            <div className='flex items-center justify-center gap-3 rounded-full bg-azure-455/10 px-4 py-[5px]'>
              <div className='text-[14px] leading-[14px] sm:text-[20px]'>
                👋
              </div>
              <div className='text-[12px] leading-[16px] font-[600] text-neutral-945 sm:text-[16px] sm:leading-[22px]'>
                HELLO LISTENER
              </div>
            </div>
            <h1 className='block text-[32px] leading-[34px] font-[700] text-neutral-945 sm:text-[48px] sm:leading-[51px] lg:text-[55px] lg:leading-[73px]'>
              Listen to academic papers{' '}
              <span className='text-azure-595'>on the go</span>
            </h1>
          </div>
          <div className='text-[16px] leading-[24px] font-[500] text-neutral-840 sm:text-[24px] lg:text-[20px] lg:leading-[30px]'>
            Save time by listening to papers anywhere, in your spare time
          </div>
          <CtaButton className='inline-block h-auto cursor-pointer rounded-full border-0 bg-azure-455 p-4 text-center text-[14px] leading-[18px] font-[600] text-neutral-50 no-underline sm:px-8 sm:py-3 sm:text-[18px] sm:leading-[24px]' />
          <div className='flex flex-col gap-4'>
            <div className='text-[16px] leading-[24px] font-[500] text-neutral-840 sm:text-[18px] sm:leading-[27px]'>
              What does it sound like?
            </div>
            <div className='flex flex-col flex-wrap gap-4 sm:flex-row'>
              <VoiceSample
                audioSrc='https://webflow-cdn.listening.com/voice-samples/will-2.mp3'
                imgSrc={voiceWillWebp}
                label='Computer Science'
              />
              <VoiceSample
                audioSrc='https://webflow-cdn.listening.com/voice-samples/liv-3.mp3'
                imgSrc={voiceLivWebp}
                label='Biology'
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
